import { ApiBase } from "../../core/api-base";
import { AdTypes } from "../../constants/ad-types";
import type * as z from "zod";
import { GetAds200Response, GetAdsQueryParams } from "../../api/generated/ads.zod";

type AdsResponse = z.infer<typeof GetAds200Response>;
export type AdItem = NonNullable<AdsResponse["data"]>[number];

export class PostsAdsApi extends ApiBase {
    public static extractAds(payload: AdsResponse): AdItem[] {
        return Array.isArray(payload?.data) ? payload.data : [];
    }

    public static async fetchAllAds(limit = 1000): Promise<AdItem[]> {
        const safeLimit = Math.max(1, Number(limit || 1000));
        const url = `/api/v1/ads?limit=${encodeURIComponent(String(safeLimit))}`;

        const response = await super.apiGet(url, { noSpinner: true });
        if (!response.ok) return [];

        const payload = (await response.json()) as AdsResponse;
        return this.extractAds(payload);
    }

    public static async fetchAds(
        adType: z.infer<typeof GetAdsQueryParams>["ad_type"] | string,
        limit: z.infer<typeof GetAdsQueryParams>["limit"] = 1,
    ): Promise<AdItem[]> {
        const safeType = String(adType || "")
            .trim()
            .toUpperCase();
        const safeLimit = Math.max(1, Number(limit || 1));
        if (!safeType) return [];
        if (!Object.values(AdTypes).includes(safeType)) return [];

        const all = await this.fetchAllAds(safeLimit);
        return all.filter((item) => String(item.ad_type || "").toUpperCase() === safeType);
    }
}
